var $;

$ = require('jquery');

module.exports = (function() {
  var jobsSlideshow, mobileMenuCheck, mobileMenuClickHandler, showMobileMenu;
  $(document).ready(function() {
    mobileMenuCheck();
    mobileMenuClickHandler();
  });
  $(window).resize(function() {
    mobileMenuCheck();
  });
  jobsSlideshow = jobsSlideshow = function() {
    var interval, j, job, jobNumber;
    interval = 5000;
    job = $(".job");
    job.hide();
    jobNumber = {
      0: $(".job0"),
      1: $(".job1"),
      2: $(".job2"),
      3: $(".job3"),
      4: $(".job4")
    };
    jobNumber[0].fadeIn();
    j = 0;
    setInterval((function() {
      job.fadeOut().promise().then(function() {
        j += 1;
        if (j > 4) {
          j = 0;
        } else {

        }
        jobNumber[j].fadeIn();
      });
    }), interval);
  };
  mobileMenuClickHandler = mobileMenuClickHandler = function() {
    $(".nav, section, footer").click(function(e) {
      var clickTarget, navLinks;
      navLinks = $(".nav-links");
      clickTarget = e.target.className;
      if (clickTarget === "nav-mobile-button") {
        if (!navLinks.hasClass("active")) {
          navLinks.addClass("active");
        } else {
          navLinks.removeClass("active");
        }
      } else {
        if (navLinks.hasClass("active")) {
          navLinks.removeClass("active");
        }
      }
    });
  };
  mobileMenuCheck = showMobileMenu = function() {
    if (window.innerWidth < 768) {
      $(".nav-links").addClass("mobile");
    } else {
      $(".nav-links").removeClass("mobile");
    }
  };
})();
